"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQuestionModel = void 0;
const pythia_libs_1 = require("@yandex-int/pythia-libs");
const types_1 = require("src/components/types");
function getQuestionModel(questions, questionId) {
    const question = questions[questionId];
    if ((0, types_1.isTableQuestion)(question)) {
        const boundQuestionsRevision = {};
        question.boundQuestions.forEach(q => {
            boundQuestionsRevision[q] = questions[q];
        });
        question.boundQuestionsRevision = boundQuestionsRevision;
    }
    return (0, pythia_libs_1.Question)(question);
}
exports.getQuestionModel = getQuestionModel;
